import styled from 'styled-components';

type ItemSummaryReportProps = {
  label: string;
  value: string;
  icon: React.ReactNode;
  valueColor?: string;
};

export const ItemSummaryReport = ({ label, value, icon, valueColor }: ItemSummaryReportProps) => {
  return (
    <DashboardItemStyled>
      <div className='content'>
        <p className='label'>{label}</p>
        <p className='value' style={{ color: valueColor }}>
          {value}
        </p>
      </div>
      {icon}
    </DashboardItemStyled>
  );
};

const DashboardItemStyled = styled.div`
  display: flex;
  padding: 8px;
  gap: 8px;
  flex: 1;
  border-radius: 8px;
  border: 1px solid #ccd4dc;
  background: #fff;
  position: relative;
  justify-content: space-between;
  align-items: center;

  .content {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .label {
      color: #505050;
      font-size: 18px;
      font-weight: 600;
      line-height: 30px;
      text-transform: capitalize;
    }

    .value {
      color: #1d2129;
      font-size: 24px;
      font-weight: 600;
    }
  }
`;
